import { IPaginationParams } from './types'

export const defaultPagination = (): IPaginationParams => ({
  limit: 25,
  offset: 0,
})
